import { type ReactNode, useState } from 'react'

import '@/components/organisms/markdown-editor/markdown-editor.css'

import { cn } from '@/lib/utils'
import type { ContentBriefData } from './content-brief.interface'
import { ContentBriefBlockList } from './content-brief-block-list.atom'
import { ContentBriefHeaderActions } from './content-brief-header-actions.molecule'
import { ContentBriefProceedModal } from './content-brief-proceed-modal.molecule'
import { ContentBriefShadowView } from './content-brief-shadow-view.molecule'
import { useContentBriefContentState } from './use-content-brief-content-state.hook'

export interface ContentBriefContentProps {
  data: ContentBriefData
  className?: string
}

export const ContentBriefContent: React.FC<ContentBriefContentProps> = ({
  data,
  className,
}): ReactNode => {
  const { content, isHtml = false, isReadOnly = false, onProceed, onDownload, onCopy } = data
  const [isProceedModalOpen, setIsProceedModalOpen] = useState(false)
  const state = useContentBriefContentState({ content, isHtml, onProceed, onCopy })

  return (
    <div
      className={cn(
        'content-brief-content flex h-full min-w-0 flex-col overflow-hidden',
        className
      )}
    >
      <ContentBriefHeaderActions
        commentCount={state.commentCount}
        isHtml={isHtml}
        isReadOnly={isReadOnly}
        onDownload={onDownload}
        onCopy={state.handleCopy}
        onProceed={() => setIsProceedModalOpen(true)}
      />
      {isHtml ? (
        <ContentBriefShadowView
          htmlContent={content}
          commentMap={state.commentMap}
          onCommentChange={state.handleCommentChange}
          onBlocksReady={state.handleShadowBlocksReady}
        />
      ) : (
        <ContentBriefBlockList
          blockList={state.markdownBlockList}
          commentMap={state.commentMap}
          onCommentChange={state.handleCommentChange}
          isReadOnly={isReadOnly}
        />
      )}
      {!isReadOnly && (
        <ContentBriefProceedModal
          isOpen={isProceedModalOpen}
          onOpenChange={setIsProceedModalOpen}
          feedbackList={state.feedbackList}
          onProceed={state.handleProceedConfirm}
        />
      )}
    </div>
  )
}
